import {ACTION} from './constants';

const initialState = { isLoading: false };

export default function JanNiveshReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.JAN_NIVESH:
            return {...state, janniveshlist:{...action.data}};
        default:
            return state;
    }
}